import { Component, Input } from '@angular/core';
import { WindowRef } from '@ca/core/services';

@Component({
    selector: 'ca-html-preview-frame',
    templateUrl: './html-preview-frame.component.html',
    styleUrls: ['./html-preview-frame.component.scss'],
    host: {
        '[class.w-100]': 'inlineHtmlContent != null',
    },
})
export class HtmlPreviewFrameComponent {
    /**
     * DOM tree which will be put into the iFrame
     */
    @Input() dataToRender?: string;

    constructor(private windowRef: WindowRef) {}

    get isLocalhost(): boolean {
        return this.windowRef.isLocalhost;
    }
}
